<template>
  <el-col :span="24">
    <el-form-item
      size="small"
      v-for="form in forms"
      :key="form.label"
      :prop="form.id"
      :label="form.label"
      :rules="form.rules"
    >
      <el-input
        v-if="form.type == 'text' || form.type == 'password' || form.type == 'number'"
        v-model="TermOfService[form.id]"
        :type="form.type"
        :placeholder="`Please input ${form.label}`"
      ></el-input>
      <el-input
        v-else-if="form.type == 'textarea'"
        type="textarea"
        :rows="2"
        :placeholder="`Please input ${form.label}`"
        v-model="TermOfService[form.id]"
      ></el-input>
      <el-select
        v-else-if="form.type == 'select'"
        v-model="TermOfService[form.id]"
        :placeholder="`Please select ${form.label}`"
      >
        <el-option
          v-for="item in form.data"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
  </el-col>
</template>

<script>
export default {
  props: ["TermOfService"],
  data() {
    return {};
  },
  computed: {
    forms() {
      return [
        {
          type: "text",
          id: "title",
          label: "Title",
          rules: []
        },
        {
          type: "text",
          id: "intro",
          label: "Intro",
          rules: []
        },
        {
          type: "textarea",
          id: "description",
          label: "Description",
          rules: []
        }
      ];
    }
  }
};
</script>

<style>
</style>
